export const inputTheme = {
  variants: {
    outline: {
      field: {
        _focusVisible: { borderColor: 'focus', boxShadow: '0 0 0 1px var(--cassini-colors-focus)' },
      },
    },
  },
};
